"use client";

import { useEffect, useState } from "react";

export function useScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const bannerHeight = window.innerHeight;

    const onScroll = () => {
      const y = window.scrollY;
      setProgress(Math.min(y / bannerHeight, 1));
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return progress;
}
